import script from "./AddArticle.vue?vue&type=script&setup=true&lang=js"
export * from "./AddArticle.vue?vue&type=script&setup=true&lang=js"

import "./AddArticle.vue?vue&type=style&index=0&id=7cd618dd&scoped=true&lang=css"

import exportComponent from "D:\\My Project\\NewBlog\\WEB\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7cd618dd"]])

export default __exports__